import { ConsoleLogger } from "src/core/logger/ConsoleLogger";

export default new ConsoleLogger();
